const globalConstants = {
    appName: 'Nabin Kawan',
    appDesc: 'Senior Software Engineer building AI video platforms and the durable pipelines behind them. Based in Bhaktapur, Nepal.',
    title: 'Nabin Kawan · Senior Software Engineer',
    favIcon: 'favIcon',
    twitterHandle: '',
    titleImg: 'titleImg',
    socialPreview: {
        url: 'https://www.kawannabin.com.np/',
        title: 'Nabin Kawan · Senior Software Engineer',
        desc: 'Senior Software Engineer building AI video platforms and the durable pipelines behind them. Based in Bhaktapur, Nepal.',
        image: '/images/thumbnail.png'
    },
    consoleWarningTitle: `%cStop!`,
    consoleWarningDescription: `%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a feature, it is a scam and will give them access to your sensitive information.`,
    imageTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/svg+xml']
};

export default globalConstants;
